module.exports = __webpack_public_path__ + "img/norcott_t3.a1045051.jpg";